import { TreeNode } from './tree-node';

export class LeafNode<TContainer, TLeaf> extends TreeNode<TContainer, TLeaf> {
  constructor(public data: TLeaf) {
    super();
  }

  readonly kind = 'leaf' as const;
}
